
/*************************** Dependencia ************************************/
// Acción registrar dependencia
export const REGISTRAR_DEPENDENCIA_REQUEST = 'REGISTRAR_DEPENDENCIA_REQUEST';
export const REGISTRAR_DEPENDENCIA_SUCCESS = 'REGISTRAR_DEPENDENCIA_SUCCESS';
export const REGISTRAR_DEPENDENCIA_FAIL = 'REGISTRAR_DEPENDENCIA_FAIL';

// Acción Lista mantenedor dependencias
export const LISTA_MANTENEDOR_DEPENDENCIA_REQUEST = 'LISTA_MANTENEDOR_DEPENDENCIA_REQUEST';
export const LISTA_MANTENEDOR_DEPENDENCIA_SUCCESS = 'LISTA_MANTENEDOR_DEPENDENCIA_SUCCESS';
export const LISTA_MANTENEDOR_DEPENDENCIA_FAIL = 'LISTA_MANTENEDOR_DEPENDENCIA_FAIL';

// Acción Trae Combo Servicios
export const COMBO_SERVICIO_MANTENEDOR_REQUEST = 'COMBO_SERVICIO_MANTENEDOR_REQUEST';
export const COMBO_SERVICIO_MANTENEDOR_SUCCESS = 'COMBO_SERVICIO_MANTENEDOR_SUCCESS';
export const COMBO_SERVICIO_MANTENEDOR_FAIL = 'COMBO_SERVICIO_MANTENEDOR_FAIL';

/*************************** Servicio ************************************/

// Acción Obtener Max servicio
export const OBTENER_MAX_SERVICIO_REQUEST = 'OBTENER_MAX_SERVICIO_REQUEST';
export const OBTENER_MAX_SERVICIO_SUCCESS = 'OBTENER_MAX_SERVICIO_SUCCESS';
export const OBTENER_MAX_SERVICIO_FAIL = 'OBTENER_MAX_SERVICIO_FAIL';

// Acción registrar servicios
export const REGISTRAR_SERVICIO_REQUEST = 'REGISTRAR_SERVICIO_REQUEST';
export const REGISTRAR_SERVICIO_SUCCESS = 'REGISTRAR_SERVICIO_SUCCESS';
export const REGISTRAR_SERVICIO_FAIL = 'REGISTRAR_SERVICIO_FAIL';

// Acción Lista mantenedor servicios
export const LISTA_MANTENEDOR_SERVICIO_REQUEST = 'LISTA_MANTENEDOR_SERVICIO_REQUEST';
export const LISTA_MANTENEDOR_SERVICIO_SUCCESS = 'LISTA_MANTENEDOR_SERVICIO_SUCCESS';
export const LISTA_MANTENEDOR_SERVICIO_FAIL = 'LISTA_MANTENEDOR_SERVICIO_FAIL';

/*************************** Usuario ************************************/
// Acción registrar usuarios
export const REGISTRAR_USUARIO_REQUEST = 'REGISTRAR_USUARIO_REQUEST';
export const REGISTRAR_USUARIO_SUCCESS = 'REGISTRAR_USUARIO_SUCCESS';
export const REGISTRAR_USUARIO_FAIL = 'REGISTRAR_USUARIO_FAIL';

// Acción Lista mantenedor usuarios
export const LISTA_MANTENEDOR_USUARIO_REQUEST = 'LISTA_MANTENEDOR_USUARIO_REQUEST';
export const LISTA_MANTENEDOR_USUARIO_SUCCESS = 'LISTA_MANTENEDOR_USUARIO_SUCCESS';
export const LISTA_MANTENEDOR_USUARIO_FAIL = 'LISTA_MANTENEDOR_USUARIO_FAIL';


/*************************** Especies ************************************/
// Acción Lista mantenedor especies
export const LISTA_MANTENEDOR_ESPECIES_REQUEST = 'LISTA_MANTENEDOR_ESPECIES_REQUEST';
export const LISTA_MANTENEDOR_ESPECIES_SUCCESS = 'LISTA_MANTENEDOR_ESPECIES_SUCCESS';
export const LISTA_MANTENEDOR_ESPECIES_FAIL = 'LISTA_MANTENEDOR_ESPECIES_FAIL';

// Acción Trae combo Cuentas
export const COMBO_CUENTAS_MANTENEDOR_REQUEST = 'COMBO_CUENTAS_MANTENEDOR_REQUEST';
export const COMBO_CUENTAS_MANTENEDOR_SUCCESS = 'COMBO_CUENTAS_MANTENEDOR_SUCCESS';
export const COMBO_CUENTAS_MANTENEDOR_FAIL = 'COMBO_CUENTAS_MANTENEDOR_FAIL';

// Acción Registrar Especies
export const REGISTRAR_ESPECIE_REQUEST = 'REGISTRAR_ESPECIE_REQUEST';
export const REGISTRAR_ESPECIE_SUCCESS = 'REGISTRAR_ESPECIE_SUCCESS';
export const REGISTRAR_ESPECIE_FAIL = 'REGISTRAR_ESPECIE_FAIL';

// Acción Actualizar Especies
export const ACTUALIZAR_ESPECIE_REQUEST = 'ACTUALIZAR_ESPECIE_REQUEST';
export const ACTUALIZAR_ESPECIE_SUCCESS = 'ACTUALIZAR_ESPECIE_SUCCESS';
export const ACTUALIZAR_ESPECIE_FAIL = 'ACTUALIZAR_ESPECIE_FAIL';

/*************************** Proveedores ************************************/

// Acción Lista mantenedor Proveedores
export const LISTA_MANTENEDOR_PROVEEDORES_REQUEST = 'LISTA_MANTENEDOR_PROVEEDORES_REQUEST';
export const LISTA_MANTENEDOR_PROVEEDORES_SUCCESS = 'LISTA_MANTENEDOR_PROVEEDORES_SUCCESS';
export const LISTA_MANTENEDOR_PROVEEDORES_FAIL = 'LISTA_MANTENEDOR_PROVEEDORES_FAIL';

// Acción registrar Proveedores
export const REGISTRAR_PROVEEDORES_REQUEST = 'REGISTRAR_PROVEEDORES_REQUEST';
export const REGISTRAR_PROVEEDORES_SUCCESS = 'REGISTRAR_PROVEEDORES_SUCCESS';
export const REGISTRAR_PROVEEDORES_FAIL = 'REGISTRAR_PROVEEDORES_FAIL';

// Acción Obtener Max proveedor
export const OBTENER_MAX_PROVEEDOR_REQUEST = 'OBTENER_MAX_PROVEEDOR_REQUEST';
export const OBTENER_MAX_PROVEEDOR_SUCCESS = 'OBTENER_MAX_PROVEEDOR_SUCCESS';
export const OBTENER_MAX_PROVEEDOR_FAIL = 'OBTENER_MAX_PROVEEDOR_FAIL';

// Acción actualizar Proveedores
export const ACTUALIZAR_PROVEEDOR_REQUEST = 'ACTUALIZAR_PROVEEDOR_REQUEST';
export const ACTUALIZAR_PROVEEDOR_SUCCESS = 'ACTUALIZAR_PROVEEDOR_SUCCESS';
export const ACTUALIZAR_PROVEEDOR_FAIL = 'ACTUALIZAR_PROVEEDOR_FAIL';

/*************************** Componentes ************************************/

export const LISTA_MANTENEDOR_COMPONENTES_REQUEST = 'LISTA_MANTENEDOR_COMPONENTES_REQUEST';
export const LISTA_MANTENEDOR_COMPONENTES_SUCCESS = 'LISTA_MANTENEDOR_COMPONENTES_SUCCESS';
export const LISTA_MANTENEDOR_COMPONENTES_FAIL = 'LISTA_MANTENEDOR_COMPONENTES_FAIL';
